import ResponseError from "../../utils/ResponseError"
import { StatusCodes } from "http-status-codes"
import Settings from "../../utils/CarrotConfig"

// For the internal Change Healthcare log viewer we are catching the errors on the page instead of letting them
// reach the ErrorWrapper, so we need to redirect 401s separately.
export default function changeHealthcare401Redirect(error) {
  if ((error as ResponseError)?.statusCode === StatusCodes.UNAUTHORIZED) {
    const currentUrl = encodeURIComponent(window.location.href)
    window.location.href = `${Settings.LOGIN_URL}?ReturnUrl=${currentUrl}`
    return null
  }
}
